module.exports = __webpack_public_path__ + "img/download_12.33c5f3e8.png";